import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("bv_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  const empresa = localStorage.getItem("bv_empresa");
  if (empresa) config.headers["X-Empresa-Id"] = empresa;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem("bv_token");
      if (window.location.pathname !== "/login") {
        window.location.href = "/login";
      }
    }
    if (err.response?.status === 403) {
      const d = err.response?.data?.detail;
      // Empresa armazenada ficou inválida (acesso revogado) — limpa e recarrega
      if (typeof d === "string" && d.toLowerCase().includes("empresa") && localStorage.getItem("bv_empresa")) {
        localStorage.removeItem("bv_empresa");
        window.location.reload();
      }
    }
    return Promise.reject(err);
  }
);

export function formatApiError(detail) {
  if (detail == null) return "Erro inesperado. Tente novamente.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

/** Download a file from the API using the auth token and trigger save dialog.
 *  Erros vêm como Blob (responseType blob) — converte para JSON para que
 *  `formatApiError(e.response.data.detail)` mostre a mensagem real. */
export async function downloadFile(path, filename, params = {}) {
  let r;
  try {
    r = await api.get(path, { params, responseType: "blob" });
  } catch (e) {
    const data = e.response?.data;
    if (data instanceof Blob) {
      const txt = await data.text().catch(() => "");
      try { e.response.data = JSON.parse(txt); }
      catch { e.response.data = { detail: txt && txt.length < 300 ? txt : `Erro ${e.response.status} ao gerar o arquivo.` }; }
    } else if (!e.response) {
      e.response = { data: { detail: "Sem resposta do servidor ao gerar o arquivo (tempo esgotado ou conexão). Tente um período menor." } };
    }
    throw e;
  }
  const cd = r.headers["content-disposition"] || "";
  const match = /filename="?([^"]+)"?/i.exec(cd);
  const fname = match ? match[1] : filename;
  const url = window.URL.createObjectURL(new Blob([r.data]));
  const a = document.createElement("a");
  a.href = url;
  a.download = fname;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
}

export default api;
